import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["id", "issueTypeID", "reportID", "version"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createHashHistory } from 'history';
import changeActionFactory from './factories/changeActionFactory';
import contentChangeActionFactory from './factories/contentChangeActionFactory';
import entityActionFactory from './factories/entityActionFactory';
import issueConstants from '../constants/issueConstants';
import uploadActionFactory from './factories/uploadActionFactory';
import tokenErrorActions from './tokenErrorActionCreators';
import notificationActions from './notificationActionCreators';
import { post, remove } from './ajax';

// define the basic actions, and include page and change actions.
const changeActions = changeActionFactory('issue', 'issues');
const entityActions = entityActionFactory('issue', 'issues');
const contentChangeActions = contentChangeActionFactory('issue', 'issues');
const uploadActions = uploadActionFactory('issue', 'issues', true, 'Photo');
const hashHistory = createHashHistory();
const includedActions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeActions), entityActions), uploadActions), contentChangeActions);
const handleRedirect = (dispatch, getState) => {
  const entityState = getState().issue;
  dispatch(entityActions.serverIndex(entityState.indexQuery, true, true));
  hashHistory.push('issues');
};
const serverSave = (version, handleRedirectIn, postOpts) => contentChangeActions.serverSave(version, handleRedirectIn || handleRedirect, postOpts);
/**
 * indexByReport
 * @param data
 * arguments are a reportID and name (reportType identifier and reportNumber combined):
 * reportID: 'some-report-uuid',
 * reportName: 'Daily Inspection Report 1'
 */
const indexByReport = (reportID, reportName, indexQuery) => ({
  type: issueConstants.INDEX_BY_REPORT,
  reportID,
  reportName,
  indexQuery
});
const createIssuePhoto = (id, createdDate, issuePhotos, activeID, userID) => {
  // create a new issuePhoto object
  const photo = {
    id,
    created: createdDate,
    modified: createdDate,
    metaDeleted: 0,
    appCreated: createdDate,
    appCreatorID: userID,
    issueID: activeID
  };

  // attach new issuePhoto to active issue
  issuePhotos.push(photo);
  return includedActions.change(activeID, 'issuePhotos', issuePhotos);
};
const serverCreateIssue = function serverCreateIssue(patch) {
  let navigate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  return dispatch => {
    const _patch$patch = patch.patch,
      id = _patch$patch.id,
      issueTypeID = _patch$patch.issueTypeID,
      reportID = _patch$patch.reportID,
      version = _patch$patch.version,
      secondaryPatch = _objectWithoutProperties(_patch$patch, _excluded);
    return dispatch(contentChangeActions.serverSaveMergePatches(id, [{
      id,
      patch: {
        issueTypeID,
        reportID,
        id,
        version
      }
    }, {
      id,
      patch: secondaryPatch
    }], (savedID, data) => dispatcher => {
      dispatcher(includedActions.saveSuccess(savedID, data));
      dispatcher(includedActions.show(savedID));
      dispatcher(includedActions.showSuccess(savedID, data[0]));
      navigate(savedID);
    }));
  };
};
const serverDeleteIssues = ids => async (dispatch, getState) => {
  try {
    await remove('/issues', null, ids);
  } catch (err) {
    return dispatch(tokenErrorActions.handleError(err, 'issue', () => {
      dispatch(notificationActions.error({
        message: err.message,
        id: 'server_delete_issues_failure'
      }, {
        autoClose: 2000
      }));
    }, serverDeleteIssues.bind(this, ids), handleRedirect));
  }
  const _getState = getState(),
    issue = _getState.issue;
  await dispatch(includedActions.serverIndex(issue.indexQuery, false));
  return dispatch(notificationActions.info({
    message: "Successfully deleted ".concat(ids.length, " issue").concat(ids.length === 1 ? '' : 's', ".")
  }));
};
const serverSaveAssignments = (id, assignments) => async dispatch => {
  try {
    await post('/issues/assignments', assignments);
    dispatch(entityActions.selectClearAll());
    return dispatch(notificationActions.success({
      message: 'Successfully applied assignment changes.',
      id: "".concat(id, "_success")
    }, {
      autoClose: 2000
    }));
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'issue', () => {
      dispatch(notificationActions.error({
        message: e.message,
        id: "".concat(id, "_failure")
      }, {
        autoClose: 2000
      }));
    }, serverSaveAssignments.bind(this, id, assignments), handleRedirect));
  }
};
const issueActions = _objectSpread(_objectSpread({}, includedActions), {}, {
  serverDeleteIssues,
  createIssuePhoto,
  indexByReport,
  serverSave,
  serverSaveAssignments,
  serverCreateIssue
});
export default issueActions;